import { combineActions, handleActions } from 'redux-actions'

import { getAiObjectsByContent } from '../actions'

const defaultState = false

export default handleActions(
  {
    [getAiObjectsByContent.request]() {
      return true
    },
    [combineActions(getAiObjectsByContent.success, getAiObjectsByContent.failed, getAiObjectsByContent.cancel)]() {
      return false
    },
  },
  defaultState
)
